export function getAdoptUrl () {
    return `https://${process.env.VUE_APP_ADOPT_DOMAIN}`;
}
